export default "__VITE_ASSET__Dt2muj1n__"